import ManageCompanyTabs from './ManageCompanyTabs';

export default ManageCompanyTabs;
